import { render, staticRenderFns } from "./EventBubble.vue?vue&type=template&id=482ef466&scoped=true"
import script from "./EventBubble.vue?vue&type=script&lang=js"
export * from "./EventBubble.vue?vue&type=script&lang=js"
import style0 from "./EventBubble.vue?vue&type=style&index=0&id=482ef466&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482ef466",
  null
  
)

export default component.exports